import { render, staticRenderFns } from "./ParametrizacoesList.vue?vue&type=template&id=a89708ba&scoped=true"
import script from "./ParametrizacoesList.vue?vue&type=script&lang=js"
export * from "./ParametrizacoesList.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacoesList.vue?vue&type=style&index=0&id=a89708ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89708ba",
  null
  
)

export default component.exports